<template>
  <div class="cases-container">
    <template v-if="theme === 'swiper'">
      <swiper class="cases-lists-container" :class="theme" v-if="lists.length > 0" ref="case-swiper" :options="options">
        <swiper-slide class="grid__item-case scroll-up-to hoverEffect animated" :class="{
          isSpecial: item.isSpecial && theme === 'special'
        }" v-for="(item, index) in lists" :key="index">
          <router-link tag="div" :click="routergo(item.id,item.imageType)">
            <div class="item__cover">
              <img class="lazyload" :src="item.title_picture_url " alt="" />
            </div>
            <div class="item__case-info">
              <div class="case-info__name">
                <div class="name">{{ item.title }}</div>
              </div>
            </div>

          </router-link>
        </swiper-slide>
      </swiper>
    </template>
    <template v-else>
      <div class="cases-lists-container" :class="theme" v-if="lists.length > 0">
        <div @click.stop="routergo(item.id, item.imageType)" class="grid__item-case" :class="{
          isSpecial: item.isSpecial && theme === 'special',
          isSpecialBig: item.isSpecialBig && theme === 'special',
          'scroll-up-to hoverEffect':
            theme !== 'manage' && theme !== 'claim' && theme !== 'collect-list',
          mangeHover: theme === 'manage' || theme === 'claim'
        }" v-for="(item, index) in lists" :key="index">

          <div class="item__case-inner">
            <div class="item__cover">
              <el-image :src="item.title_picture_url " fit="cover"></el-image>
            </div>
            <div class="item__case-info">
              <div class="case-info__name">
                <div class="name">{{ item.title }}</div>
              </div>
              <div class="case-info__address">{{ item.prov_name }}</div>
            </div>

          </div>
        </div>
      </div>
      <Empty hint="没有找到相关信息" v-else></Empty>
      <Pagination :config="isShowPagination" v-if="isShowPagination && showLimit === 0 && lists.length > 0"
        class="component-pagination"></Pagination>
    </template>

    <template>
      <div>
        <el-dialog title="用户授权协议" :visible.sync="dialogVisible" width="50%">
          <el-form :model="authMobileFormModel" ref="formRef" label-width="50%" size="small"
            class="designer-add-info-c clearfix">
            <div class="lsm-container" style="height:300px;">
              <el-scrollbar class="scrollbar-wrapper" style="height:100%;line-height:22px;">
                本《信息授权协议》（以下简称“本协议”）由上海材赋信息科技有限公司，即材料在线平台（以下简称“材料在线”）与用户（以下简称“您”）进行缔结，对双方具有同等法律效力。<br />
                <br />
                在您使用“灵感板块功能”相关服务（以下简称“本服务”）之前，请您务必审慎阅读、充分理解本协议各条款内容。如果您不同意本协议的任一或全部条款内容，请不要以确认形式进行下一步操作（包括但不限于勾选/点击同意、填写/提交个人信息等）或使用本服务。一旦您以确认形式进行下一步操作或使用本服务的，即表示您与材料在线已达成协议关系，您自愿接受本协议并遵守本协议项下的全部约定。<br />

                1.在您点击确定/授权后，当您使用灵感板块服务时，我们会将您的账户、手机号码及相关信息共享给材料在线委托的技术服务代理商苏州零泉科技有限公司。前述第三方将使用您的前述信息用于第三方为您提供服务。页面提示上可能会展示具体授权对象、授权字段名称、范围等，授权字段通过加密通道传递给第三方。<br />
                2. 您理解，材料在线是中立平台的提供者，第三方服务由该第三方独立运营并独立承担全部责任。<br />
                3.
                材料在线在遵守“合法正当、最小必要、目的明确”原则的前提下共享您的个人信息。我们将对个人信息的共享活动事先进行个人信息保护影响评估，对输出形式、流转、使用等采取有效的技术保护措施。在合作协议层面，严格要求合作伙伴的信息保护义务与责任，与业务合作伙伴在合作前签署关于数据安全的保护协议。<br />
                4. 材料在线深知个人信息对您的重要性，因此材料在线非常重视保护您的个人信息，亦将您的个人信息以高度审慎的义务对待和处理。<br />
                5. 本协议的解释及争议解决均应适用中华人民共和国大陆地区法律。如就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向被告住所地人民法院提起诉讼。<br />
                6. 如您在阅读本协议过程中有任何疑惑或其他相关事宜的，您可通过材料在线客服渠道联系材料在线；同时，您也可以发邮件至cailiaozaixian@163.com。材料在线会尽快为您作出解答。<br />


              </el-scrollbar>
            </div>
            <br />
            <p style="text-align:center">下滑滚动查看协议内容</p>

            <br />
            <el-radio v-model="radio" label="1" color='#fabe00'><label>授权账号信息及手机号，以便使用该功能</label>
            </el-radio>

            <el-form-item>
              <el-button type="primary" @click="toCreateAuth">确 定</el-button>
              <el-button @click="cancelCreateAuth" class="el-button-cancel">取 消</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
    </template>

  </div>
</template>

<script>
import { getLqRedirectUrl } from '@/api/lq';
import { createAuth, isAuth } from '@/api/user';
import { handlerAddLikes } from '@/assets/utils/handler';
import localstorage from '@/assets/utils/localstorage';
import Pagination from '@/components/pagination.vue';
import { toBg } from '@/filters';
import Empty from '@/pages/common/empty.vue';
import router from '@/router';
import * as dict from '@/store/storage-dict';
import { Message } from 'element-ui';
import 'swiper/css/swiper.css';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

const statusMap = {
  0: '待审核',
  1: '审核通过',
  2: '审核驳回',
};

export default {
  filters: {
    statusText(val) {
      return statusMap[val];
    },
  },
  components: {
    Pagination,
    Swiper,
    SwiperSlide,
    Empty,
  },
  props: {
    lqs: {
      default: () => [],
      type: Array,
    },
    isLikes: {
      type: Boolean,
      default: false,
    },
    isShowPagination: {
      type: Object,
      default: null,
    },
    showLimit: {
      type: Number,
      default: 0,
    },
    theme: {
      type: String,
      default: 'big',
    },
  },
  data() {
    return {
      radio: '1',
      currItemObj: {
        pageType: 1,
        id: 0,
        imageType: 1,
      },
      authMobileFormModel: {
        authMobile: false,
      },
      isAuthEd: false,
      dialogVisible: false,
      lists: [],
      options: {
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        slidesPerView: this.$isMobile ? 2 : 3,
        slidesPerGroup: this.$isMobile ? 2 : 3,
        loop: true,
        init: false,
      },
      likesStatus: this.isLikes,
    };
  },
  watch: {
    lqs() {
      this.renderLists();
    },
  },
  created() {
    this.renderLists();
    this.checkisAuthEd();
  },
  mounted() {
    const that = this;
    if (that.$refs['case-swiper']) {
      that.$nextTick(() => {
        const space = parseInt(
          window
            .getComputedStyle(document.querySelector('.grid__item-case'), null)
            .getPropertyValue('padding-left'),
          0,
        );
        const { options } = that;
        options.slidesOffsetBefore = space * 2;
        setTimeout(() => {
          that.$refs['case-swiper'].$swiper.init();
        }, 500);
      });
    }
  },
  methods: {
    cancelCreateAuth() {
      this.dialogVisible = false;
    },
    async toCreateAuth() {
      this.dialogVisible = false;
      await createAuth({
        mobile: this.authMobileFormModel.authMobile == true ? 1 : 0
      });

      const res = await getLqRedirectUrl(this.currItemObj);
      window.open(res.data)
    },
    async checkisAuthEd() {
      if (this.isAuthEd == true) {
        return;
      }
      const res = await isAuth();
      this.isAuthEd = res.data;
    },


    renderLists() {
      if (this.lqs) {
        if (this.theme === 'special') {
          this.lists = this.lqs
            .map((item, index) => {
              const temp = item;
              if (this.$isMobile) {
                temp.isSpecial = index % 6 === 0 || index % 6 === 1;
              } else {
                temp.isSpecial = index % 6 === 1 || index % 6 === 2;
                temp.isSpecialBig = index % 6 === 0;
              }

              return temp;
            })
            .filter((item, index) => index < 6);
        } else {
          this.lists = this.lqs;
        }
      }
    },
    toBg(val) {
      return toBg(val);
    },
    async routergo(id, imageType) {

      this.currItemObj.id = id;
      this.currItemObj.imageType = imageType;

      if (!localstorage.get(dict.token)) {
        Message({
          type: 'error',
          message: '请您先登录',
          duration: 1000,
          onClose() {
            router.push({
              path: '/login',
            });
          },
        });
        return false;
      }
      if (this.isAuthEd != true) {
        this.dialogVisible = true;
      }
      else {
        const res = await getLqRedirectUrl(this.currItemObj);
        window.open(res.data)
      }
    },
    async onLikes(isLikes, id) {
      if (!isLikes) {
        await handlerAddLikes(id);
      }
      const msg = isLikes ? '已经取消点赞' : '点赞成功';
      this.likesStatus = !isLikes;
      this.$message({
        type: 'success',
        message: msg,
      });
    },
    onEdit(id) {
      this.$router.push({
        path: `/my/case/${id}`,
      });
    },
    onDelete(id) {
      this.$emit('onDelete', id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_mixin";

.component-pagination {
  margin-top: px2vw(98 - 29);
}

.el-button-cancel {
  color: #fff;
  background-color: #333333;
  border-color: #333333;
}

.el-radio__label {
  color: #000 !important;
  margin-right: 10px;
  font-weight: 200;

}

.el-radio__input.is-checked {
  color: #fabe00 !important;
}

.el-radio__input.is-checked .el-radio__inner {
  background: #fabe00 !important;
  border-color: #fabe00 !important;
}
</style>
